var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-logout",on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-power-off"}),_vm._v(" Sair ")])}
var staticRenderFns = []

export { render, staticRenderFns }